<template>
  <div class="flex h-fit flex-col gap-2 rounded-2xl border-4 border-neutral-600 p-4">
    <span class="text-2xl">Feuerlöscher</span>
    <label for="checked">Überprüft:</label>
    <input
      type="number"
      id="checked"
      name="checked"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.checked"
      @change="dataStore.update()"
      required
    />
    <label for="passed">Bestanden:</label>
    <input
      type="number"
      id="passed"
      name="passed"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.passed"
      @change="dataStore.update()"
      required
    />
    <label for="refill">Neugefüllt:</label>
    <input
      type="number"
      id="refill"
      name="refill"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.refilled"
      @change="dataStore.update()"
      required
    />
    <label for="disposedFoam">Entsorgt Schaum:</label>
    <input
      type="number"
      id="disposedFoam"
      name="disposedFoam"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.disposedFoam"
      @change="dataStore.update()"
      required
    />
    <label for="disposedPowder6">Entsorgt Pulver 6kg:</label>
    <input
      type="number"
      id="disposedPowder6"
      name="disposedPowder6"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.disposedPowder6"
      @change="dataStore.update()"
      required
    />
    <label for="disposedPowder12">Entsorgt Pulver 12kg:</label>
    <input
      type="number"
      id="disposedPowder12"
      name="disposedPowder12"
      min="0"
      class="h-8 rounded-lg bg-neutral-800 p-2"
      v-model="fireExtinguisherCheck.disposedPowder12"
      @change="dataStore.update()"
      required
    />
    <span>Summe: {{ dataStore.getSum(fireExtinguisherCheck) }} €</span>
  </div>
</template>

<script setup lang="ts">
import { type fireExtinguisherCheckT } from "@/types";
import { useStore } from "../stores/dataStore";

const dataStore = useStore();

const props = defineProps<{
  fireExtinguisherCheck: fireExtinguisherCheckT;
}>();
</script>

<style scoped></style>
